<template>
  <div class="grid grid-cols-12 gap-4">
    <div class="col-span-12">
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12">
          <div class="mx-auto mt-2">
            <span class="lds-ring" v-if="loading">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </span>
          </div>
        </div>
      </div>
      <div class="grid grid-cols-12 gap-4 mt-2 mx-2" v-if="getCompanyFilingHistory?.data?.content?.length> 0">
        <div class="col-span-12 px-2 py-1 bg-headed_grey rounded">
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-10 mx-2 bg-gray-10 rounded px-2 py-1 font-monospace">
              <div class="grid grid-cols-12 gap-4 text-sm" v-for="(filing, idx) in getCompanyFilingHistory.data.content" :key="idx">
                <div class="col-span-2">
                  <span class="italic text-blue text-xs float-end mt-3">{{filing.filingDate.replace("T", " ")}}</span>
                </div>
                <div class="col-span-9">
                  <div class="grid grid-cols-12 gap-4">
                    <div class="col-span-1">
                      <div style="margin-top: 20px; margin-left: 20px">
                        <span class="circle"></span>
                        <div class="line"></div>
                      </div>
                    </div>
                    <div class="col-span-11 my-3">
                      <b class="text-gray"
                         v-for="(change, idx2) in filing.changes" :key="idx2">
                        {{statusTranslator(change.typeOfChangeBeingFiled)}}
                        <i v-if="idx2 < (filing.changes.length - 1)">&</i>
                      </b>
                      <p class="text-xs" v-for="(narration, idx3) in filing.narrations" :key="idx3">
                        {{narration.description}}
                      </p>
                      <i class="text-blue text-xs">{{filing.trackingNo}}</i>
                    </div>
                  </div>
                </div>
                <div class="col-span-1">
                  <i class="fa fa-check text-green text-sm mt-5"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="grid grid-cols-12 gap-4 mt-2 mx-2" v-else>
        <div class="col-span-12 px-2 py-1 bg-headed_grey rounded">
          <div class="bg-blue-50 border border-blue-300 rounded px-4 py-3 text-blue-700 text-sm">
            <i class="fa fa-info-circle mr-2"></i> No filing history yet
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch } from "vue";
import { useBusinessFileStore } from "@/stores/business-file";
import { useToast } from "@/composables";

const props = defineProps<{ brn: string }>();

const fileStore = useBusinessFileStore();
const { errorToast } = useToast();

const loading = ref(true);

const getCompanyFilingHistory = computed(() => fileStore.filing_history);

onMounted(() => {
  fileStore.fetchCompanyFilingHistory(props.brn);
});

watch(() => fileStore.filing_history, () => {
  loading.value = false;
});

watch(() => fileStore.error, (data) => {
  if (data) {
    loading.value = false;
    errorToast("Error", data.message);
  }
})

const statusTranslator = (code: string) => {
  if (code === "DORMANCY") return "Filed for Dormancy";
  if (code === "CHANGE_OF_NAME") return "Changed Company Name";
  if (code === "CHANGE_OF_ADDRESS") return "Changed Address of Company";
  if (code === "CHANGE_OF_SECRETARIES") return "Appointed a new Company Secretary";
  if (code === "CHANGE_OF_DIRECTORS") return "Changed the Company Directors";
  if (code === "CHANGE_OF_MEMBERSHIP") return "Changed membership of the Company";
  if (code === "CHANGE_SHARE_CAPITAL") return "Changed Share Capital of the Company";
  if (code === "APPEND_INFORMATION") return "Filed a Resolution";
  if (code === "FILE_FORM_18") return "Filed Form 18 to provide the Address of the Company";
  if (code === "FILE_FORM_20") return "Filed Form 20 to provide the Directors and Secretary of the Company";
  if (code === "FILE_FORM_10") return "Filed Form 10 to allot Shares of the Company";
  if (code === "FORM_13" || code === "FORM_14" || code === "FORM_15" || code === "FORM_17") return "Filed Charges";
}
</script>

